import queryString from "query-string";

export const getDetailsReboardingUrl = (source) => {
	const query = queryString.stringify({
		needs_reboarding: 1,
		details_reboarding: 1,
		source,
	});

	return `/onboarding?${query}`;
};


export const getGlobalPreferencesUrl = (source) => {
	const query = queryString.stringify({
		globalpreferences: 1,
		source,
	});

	return `/profile?${query}`;
};



// WEBPACK FOOTER //
// ./src/shared/util/globalPreferences.js